<template>
  <v-dialog
    v-if="modalIsOpen['editRecuDate']"
    v-model="modalIsOpen['editRecuDate'].isOpen"
    width="90%"
    max-width="600px"
  >
    <v-card style="border-radius: 50px">
      <!-- <v-col> {{ modalIsOpen["editRecuDate"] }} </v-col> -->
      <v-col style="font-weight: bold; font-size: 18px; color: var(--C1)" align="center">
        Choisir une date de publication
      </v-col>
      <v-divider></v-divider>
      <v-col cols="12">
        <v-row class="ma-4 mt-2" align="center" justify="center">
          <v-col v-for="n in 31" :key="n" cols="" class="pa-1" align="center">
            <v-chip
              color="var(--C1)"
              style="border: solid 1px lightgrey; cursor: pointer"
              class="button"
              @click="setNewAutoPubliDate(n)"
            >
              {{ n }}
            </v-chip>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>

  <v-dialog v-model="modalIsOpen['editShopifyArticle']" persistent fullscreen>
    <div align="center">
      <editShopifyArticle
        :closeModal="
          function () {
            modalIsOpen['editShopifyArticle'] = false;
          }
        "
        :userInformation="userInformation"
        :groupInformation="groupInformation"
        :closeFunction="
          function () {
            modalIsOpen['editShopifyArticle'] = false;
            selectedGeneratonData.modal = false;
            updatePostData();
          }
        "
        :dataForm="modalData"
        :windowHeight="windowHeight"
        :siteListe="blogListe"
      >
      </editShopifyArticle>
    </div>
  </v-dialog>

  <v-dialog v-model="showFullEdit">
    <v-card :height="windowHeight - 70 + 'px'">
      <div
        v-if="autoPostData && selectedSiteToShow && autoPostData[selectedSiteToShow.uuid]"
      >
        <v-col
          align="center"
          style="font-weight: bold; font-size: 24px; color: var(--C1)"
          class=""
        >
          <!-- Slots de plublication pour : -->
          Génération pour :
          <span style="text-transform: capitalize">{{ getDate }}</span>
          <v-divider class="mt-3"></v-divider>
        </v-col>
        <div
          v-if="
            autoPostData[selectedSiteToShow.uuid]['nbr_progra'].filter(
              (val) => val.site == selectedSiteToShow.uuid
            ).length > 0
          "
        >
          <v-col class="pb-0" style="">
            <v-row justify="left" align="center">
              <v-col cols="auto" v-if="platformToShow.length > 1" class="py-2 pr-0">
                <v-card
                  style="border-radius: 30px; border: solid 1px lightgrey"
                  variant="flat"
                >
                  <v-select
                    style="min-width: 160px"
                    density="compact"
                    label="Platforme a afficher"
                    bg-color="white"
                    v-model="selectedPlatformToShow"
                    :items="platformToShow"
                    hide-details
                  >
                  </v-select>
                </v-card>
              </v-col>
              <v-col
                cols="auto"
                class="py-2 pr-0"
                v-if="
                  selectedPlatformToShow &&
                  groupInformation.web_site_data[selectedPlatformToShow].length > 1
                "
              >
                <v-card
                  align="center"
                  style="
                    border-radius: 0px;
                    border: solid 1px lightgrey;
                    min-width: 150px;
                    background-color: white;
                  "
                  variant="text"
                >
                  <v-select
                    density="compact"
                    hide-details
                    item-title="label"
                    label="Site sélectionné"
                    return-object
                    v-model="selectedSiteToShow"
                    :items="groupInformation.web_site_data[selectedPlatformToShow]"
                  >
                  </v-select>
                </v-card>
              </v-col>
              <!-- <v-btn
                v-if="!isMobile"
                class="button ml-3"
                style="text-transform: none"
                @click="showTimer = true"
              >
                Choisir une fréquence de publication
              </v-btn> -->
              <v-col class="pr-0 pt-1" align="left" v-if="selectedKeyWords">
                <v-btn
                  variant="flat"
                  style="background-color: green; color: white; text-transform: none"
                  class="button_armo button2"
                  @click="setArticleProposal"
                >
                  Remplir les articles manquants
                </v-btn>
              </v-col>
              <div style="position: absolute; right: 5px; top: 5px">
                <v-btn
                  icon="mdi-close"
                  color="red"
                  density="xompact"
                  @click="showFullEdit = false"
                >
                </v-btn>
              </div>
              <!-- <v-btn @click="setArticleInterval(2)"> interval 2J </v-btn> -->
              <!-- <v-col align="right" cols="" style="height: 50px; position: relative">
                <v-switch
                  style="position: absolute; right: 20px; top: 0px"
                  inset
                  hide-details
                  align="center"
                  :style="{
                    color: globalActivation[selectedSiteToShow.uuid] ? '#388E3C' : 'red',
                  }"
                  :false-value="0"
                  :true-value="1"
                  v-model="globalActivation[selectedSiteToShow.uuid]"
                  @update:modelValue="
                    changeActivation(
                      globalActivation[selectedSiteToShow.uuid],
                      autoPostData[selectedSiteToShow.uuid]['nbr_progra']
                    )
                  "
                ></v-switch>
                <div>
                  <div
                    v-if="!isMobile"
                    style="
                      padding-right: 70px;
                      padding-top: 3px;
                      min-width: 300px;
                      font-weight: bold;
                    "
                  >
                    <span>
                      {{
                        !globalActivation[selectedSiteToShow.uuid]
                          ? "Activer"
                          : "Désactiver"
                      }}
                    </span>
                    toutes les publications mensuelles
                  </div>
                  <div
                    v-else
                    style="
                      padding-right: 60px;
                      padding-top: 3px;
                      min-width: 300px;
                      font-weight: bold;
                    "
                  >
                    Publication mensuel automatique
                  </div>
                </div>
              </v-col> -->
            </v-row>
          </v-col>
          <v-col class="pb-0" style="">
            <v-row align="center" justify="center">
              <v-col cols="" class="">
                <!-- :hide-footer="
                  autoPostData[selectedSiteToShow.uuid]['nbr_progra'].length <= 10
                " -->
                <v-card
                  variant="flat"
                  class="pa-2"
                  style="position: relative"
                  :style="{
                    'background-color':
                      Object.entries(isArticleSelected).length == 0 ? 'white' : 'red',
                  }"
                >
                  <v-chip
                    v-if="Object.entries(isArticleSelected).length > 0"
                    style="
                      color: white;
                      background-color: red;
                      position: absolute;
                      bottom: 15px;
                      left: 15px;
                      z-index: 10;
                      font-weight: bold;
                    "
                    density="compact"
                  >
                    Cliquer sur une ligne pour utiliser la requête cible sélectionnée
                  </v-chip>
                  <!-- :rows-per-page="15"
                  :rows-items="[15, 25, 50]" -->
                  <Vue3EasyDataTable
                    :show-index-symbol="'Slot'"
                    show-index
                    table-class-name="customize-table-creation"
                    empty-message="Aucune publications disponible"
                    header-text-direction="center"
                    body-text-direction="center"
                    :rows-per-page="getSlotToShow.length"
                    rows-of-page-separator-message="sur"
                    rows-per-page-message="Publication automatique par page"
                    @click-row="editPublication"
                    :table-height="windowHeight - 235"
                    hide-footer
                    v-if="
                      autoPostData &&
                      selectedSiteToShow &&
                      selectedSiteToShow.uuid &&
                      autoPostData[selectedSiteToShow.uuid] &&
                      autoPostData[selectedSiteToShow.uuid]['nbr_progra'] &&
                      getHeaderFromPlatform(platform) != undefined
                    "
                    :headers="getHeaders"
                    :items="getSlotToShow.sort((a, b) => a.date - b.date)"
                  >
                    <!-- <template #item-date="{ date, isGenerate, isActived, requeste }"> -->
                    <template
                      #item-date="{
                        date,
                        isGenerate,
                        isActived,
                        site,
                        isPosted,
                        publication_datetime,
                      }"
                    >
                      <div
                        cols="auto"
                        class="py-2"
                        style="font-size: 14px; font-weight: bold; color: var(--C1)"
                        align="left"
                      >
                        <div
                          v-if="
                            Object.values(groupInformation.web_site_data).filter(
                              (val) => val.length > 0
                            ) &&
                            Object.values(groupInformation.web_site_data)
                              .filter((val) => val.length > 0)[0]
                              .find((val) => val.uuid == site) &&
                            Object.values(groupInformation.web_site_data)
                              .filter((val) => val.length > 0)[0]
                              .find((val) => val.uuid == site).compte_token &&
                            Object.values(groupInformation.web_site_data)
                              .filter((val) => val.length > 0)[0]
                              .find((val) => val.uuid == site).compte_token.length > 1
                          "
                        >
                          <div
                            v-if="date != 0 && isActived != 0 && isPosted != 2"
                            class=""
                            style="font-size: 12px"
                          >
                            <div v-if="isPosted == 0">
                              Publi auto le
                              <span style="">
                                <span style="font-weight: bold; color: red">
                                  {{ formatDate(publication_datetime)[0] }}
                                </span>

                                {{ formatDate(publication_datetime)[1] }}
                              </span>
                            </div>
                            <div v-else>
                              <!-- A publier le
                          <v-chip
                            style="font-size: 16px"
                            color="var(--C1)"
                            class="ml-1"
                            density="compact"
                            >{{ date }}</v-chip
                          > -->
                              Publi auto le
                              <span style="font-weight: bold; color: red"
                                >{{ getDay(date)[0] }}
                              </span>
                              {{ getDay(date)[1] }}
                              <!-- {{ getDate }} -->
                            </div>
                          </div>
                          <div
                            v-if="isActived == 0 || isPosted == 2"
                            style="color: red; font-size: 13px; font-weight: bold"
                            align="left"
                          >
                            Publication désactivée
                          </div>
                          <div
                            v-else-if="isGenerate == 0"
                            style="font-size: 13px; font-weight: bold"
                            :style="{
                              color: date > getCurrentDateDayNum ? 'green' : '#F57C00',
                            }"
                            align="left"
                          >
                            <div v-if="date == undefined || date == 0">
                              Aucune date planifiée
                            </div>
                            <!-- <div v-else>
                            Publié le {{ getPuclicationDate(date) }} <br />
                            Disponible le {{ getPuclicationDate(date - 1) }}
                          </div> -->
                          </div>
                          <!-- <div
                          v-else-if="isGenerate == 1"
                          style="color: green; font-size: 13px; font-weight: bold"
                          align="left"
                        >
                          Article déja généré
                        </div> -->
                        </div>
                        <div v-else>
                          <!-- <div
                          v-if="isGenerate == 1"
                          style="color: green; font-size: 13px; font-weight: bold"
                          align="left"
                        >
                          Article généré
                        </div>
                        <div
                          v-else
                          style="color: red; font-size: 13px; font-weight: bold"
                          align="left"
                        >
                          Article non généré
                        </div> -->
                          <div
                            class="mt-1"
                            style="color: red; font-size: 10px; font-weight: bold"
                            align="left"
                          >
                            Aucun site n'est lié à cette génération <br />l'article ne
                            sera pas posté
                          </div>
                        </div>
                      </div>
                    </template>
                    <template #item-requeste="{ requeste }">
                      <v-card
                        color="#EEEEEE"
                        style="
                          color: black;
                          width: 100%;
                          border-radius: 0;
                          border: solid 1px lightgrey;
                          font-weight: bold;
                          font-size: 14px;
                        "
                        class="pa-3"
                        align="center"
                        variant="flat"
                      >
                        <div
                          v-if="requeste == undefined || requeste.length == 0"
                          align="left"
                          style="color: grey"
                        >
                          Si aucun article n’est renseigné, Jauris sélectionnera
                          automatiquement un article pour vous !
                        </div>
                        <div v-else>
                          {{ requeste }}
                        </div>
                      </v-card>
                    </template>
                    <template #item-isPosted="{ isPosted }">
                      <div>
                        <v-chip
                          style="font-weight: bold"
                          color="green"
                          v-if="isPosted == 1"
                        >
                          Oui
                        </v-chip>
                        <v-chip style="font-weight: bold" color="red" v-else>
                          Non
                        </v-chip>
                      </div>
                    </template>
                    <template #item-isActived="{ isActived }">
                      <div style="font-weight: bold" align="center" class="py-2">
                        <v-chip
                          :color="isActived == 1 ? 'green' : 'red'"
                          style="font-weight: bold"
                        >
                          {{ isActived == 1 ? "Oui" : "Non" }}
                        </v-chip>
                      </div>
                    </template>
                    <template #item-isGenerate="{ isGenerate, date }">
                      <v-card variant="flat" class="pa-2" color="transparent">
                        <div
                          v-if="
                            groupInformation.article_month_generated_max -
                              groupInformation.article_month_generated <=
                            0
                          "
                        >
                          <v-chip
                            v-if="isGenerate && isGenerate == 1"
                            color="green"
                            style="font-weight: bold"
                          >
                            Généré
                          </v-chip>
                          <v-chip v-else color="red" style="font-weight: bold">
                            Aucune publication disponible
                          </v-chip>
                        </div>
                        <div v-else>
                          <!-- <v-chip
                            v-if="!requeste || requeste.length == 0"
                            color="red"
                            style="font-weight: bold"
                          >
                            Article manquant
                          </v-chip> -->
                          <div>
                            <v-chip
                              v-if="isGenerate && isGenerate == 1"
                              color="green"
                              style="font-weight: bold"
                            >
                              Généré
                            </v-chip>
                            <div v-else>
                              <v-chip
                                v-if="date == 0"
                                color="red"
                                style="font-weight: bold"
                              >
                                Incomplet
                              </v-chip>
                              <v-chip
                                color="orange"
                                v-else-if="getNbrLoadingArticle < nbrMaxGeneration"
                                style="font-weight: bold"
                              >
                                En attente
                              </v-chip>
                              <v-chip v-else color="red" style="font-weight: bold">
                                Max. simultané
                              </v-chip>
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </template>
                  </Vue3EasyDataTable>
                </v-card>
              </v-col>
              <v-col
                class="pl-0 py-0"
                cols="3"
                v-if="
                  !isMobile &&
                  groupInformation &&
                  groupInformation['proposition_data'] &&
                  groupInformation['proposition_data'].length > 0 &&
                  groupInformation['proposition_data'].filter(
                    (val) => val.site_id == selectedSiteToShow.uuid
                  ).length > 0
                "
              >
                <v-card variant="text" style="color: white" class="bg">
                  <v-col class="pb-1" style="font-weight: bold" align="center">
                    Liste de requêtes cibles
                  </v-col>
                  <v-divider class="mt-1"></v-divider>
                  <v-col>
                    <v-row>
                      <v-col class="" cols="12">
                        <v-card style="">
                          <v-select
                            density="compact"
                            v-model="selectedKeyWords"
                            label="Mot clef cible"
                            item-title="term"
                            :items="
                              groupInformation['proposition_data'].filter(
                                (val) => val.site_id == selectedSiteToShow.uuid
                              )
                            "
                            return-object
                            hide-details
                          >
                            <template v-slot:label="{ label }">
                              <div align="center" style="width: 100vw; font-weight: bold">
                                {{ label }}
                              </div>
                            </template>
                            <template v-slot:selection="{ item }">
                              <div
                                align="center"
                                style="width: 100vw; font-weight: bold; font-size: 14px"
                              >
                                {{ item.title }}
                              </div>
                            </template>
                            <template v-slot:item="{ props }">
                              <v-list-item v-bind="props" align="left"> </v-list-item>
                            </template>
                          </v-select>
                        </v-card>
                      </v-col>
                      <!-- <v-col class="" cols="12" v-if="selectedKeyWords">
                    <v-card>
                      <v-select
                        density="compact"
                        label="Thème d'article proposé"
                        v-model="selectedTheme"
                        item-title="questionVerified"
                        :items="selectedKeyWords.results"
                        return-object
                        hide-details
                      >
                        <template v-slot:label="{ label }">
                          <div align="center" style="width: 100vw">
                            {{ label }}
                          </div>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div
                            align="center"
                            style="width: 100vw; font-weight: bold; font-size: 12px"
                          >
                            {{ item.title }}
                          </div>
                        </template>
                        <template v-slot:item="{ props }">
                          <v-list-item v-bind="props" align="left"> </v-list-item>
                        </template>
                      </v-select>
                    </v-card>
                  </v-col> -->
                    </v-row>
                  </v-col>
                  <v-col
                    class="pa-4"
                    style="overflow-x: auto"
                    :style="{
                      height: windowHeight - 340 + 'px',
                      'background-color': 'rgba(255, 255, 255, 0.3)',
                    }"
                  >
                    <v-row
                      align="center"
                      v-if="Object.entries(isArticleSelected).length == 0"
                    >
                      <v-col
                        v-for="(questions, a) in selectedKeyWords.results
                          .map((val) => val.results)
                          .flat()"
                        :key="a"
                        class="pa-1"
                        cols="12"
                        align="center"
                      >
                        <v-card
                          align="left"
                          class="buttonReverse pa-2"
                          style="font-size: 14px; border-radius: 5px !important"
                          :style="{
                            'background-color': getProgrammedArticleTitle.includes(
                              questions.questionVerified
                            )
                              ? 'lightgrey !important'
                              : '',
                            color: getProgrammedArticleTitle.includes(
                              questions.questionVerified
                            )
                              ? 'grey !important'
                              : '',
                          }"
                          @click="setArticle(selectedSiteToShow.uuid, questions)"
                        >
                          {{ a + 1 }} - {{ questions.questionVerified }}
                        </v-card>
                      </v-col>
                    </v-row>
                    <div v-else>
                      <div align="right" style="position: relative; top: -7px">
                        <v-btn
                          variant="flat"
                          color="red"
                          class="button_armo"
                          style="font-size: 10px"
                          density="compact"
                          @click="deleteProposition(isArticleSelected)"
                        >
                          <v-icon>mdi-delete</v-icon>
                          Supprimer la RC</v-btn
                        >
                      </div>
                      Sélectionner une ligne du tableau de publication pour utiliser la
                      requête cible :
                      <span style="font-weight: bold">
                        {{ isArticleSelected.data.questionVerified }}
                      </span>
                      <div class="mt-7" align="center">
                        <v-btn
                          style="
                            position: absolute;
                            bottom: 15px;
                            left: 15px;
                            right: 15px;
                            color: white;
                            background-color: red;
                          "
                          class="button_armo"
                          @click="isArticleSelected = {}"
                        >
                          Annuler
                        </v-btn>
                      </div>
                    </div>
                  </v-col>
                </v-card>
              </v-col>
            </v-row>
            <!-- <v-col cols="12" align="center" class="mt-0 pt-2 pb-0" style="">
          <v-btn
            density="compact"
            height="30"
            class="button"
            @click="isSavePageOpen = true"
          >
            Enregistrer
          </v-btn>
        </v-col> -->
          </v-col>
        </div>
        <div v-else>
          <div
            style="color: var(--C1); margin-top: 30vh; font-size: 19px; font-weight: bold"
            align="center"
          >
            Votre compte est en cours de paramétrage. Nous reviendrons vers vous d'ici peu
            !
          </div>
        </div>
      </div>
      <v-col v-else>
        <v-progress-circular
          :size="180"
          :width="5"
          color="var(--C1)"
          indeterminate
          style="position: fixed; top: 40%; left: 45%; font-weight: bold"
        >
          Chargement
        </v-progress-circular>
      </v-col>
    </v-card>
  </v-dialog>

  <v-dialog
    v-if="showGenerationDataInfoNow && manuelArticle"
    v-model="showGenerationDataInfoNow"
    width="100%"
    max-width="400"
  >
    <v-card>
      <v-col>
        <h3 align="center">Valider ma génération</h3>
        <!-- <div class="pt-2">
          <v-card
            class="pa-2"
            color="rgba(0,0,0,0.1)"
            style="color: var(--C1); border: solid 1px lightgrey"
            variant="flat"
          >
            <div>
              L'article sera publié le
              <span style="font-weight: bold">{{
                getPuclicationDate(selectedGeneratonData.data.date)
              }}</span>
              avec pour requête cible
              <span style="font-weight: bold">{{
                selectedGeneratonData.data.requeste
              }}</span>
            </div>
          </v-card>
        </div> -->
        <!-- <div>désactiver la publication de mon article</div> -->
        <v-col>
          <v-row align="center" justify="center">
            <v-col align="center" class="pb-0">
              <v-btn
                class="button_armo"
                style="background-color: red; color: white"
                variant="flat"
                @click="showGenerationDataInfoNow = false"
              >
                Non
              </v-btn>
            </v-col>
            <v-col align="center" class="pb-0">
              <v-btn
                class="button_armo"
                style="background-color: green; color: white"
                variant="flat"
                @click="generateArticleNow"
              >
                Oui
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-card>
  </v-dialog>

  <v-dialog
    v-if="showGenerationDataInfo && selectedGeneratonData"
    v-model="showGenerationDataInfo"
    width="100%"
    max-width="400"
  >
    <v-card>
      <v-col>
        <h3 align="center">Valider ma génération</h3>
        <div class="pt-2">
          <v-card
            class="pa-2"
            color="rgba(0,0,0,0.1)"
            style="color: var(--C1); border: solid 1px lightgrey"
            variant="flat"
          >
            <div>
              L'article sera publié le
              <span style="font-weight: bold">{{
                getPuclicationDate(selectedGeneratonData.data.date)
              }}</span>
              avec pour requête cible
              <span style="font-weight: bold">{{
                selectedGeneratonData.data.requeste
              }}</span>
            </div>
          </v-card>
        </div>
        <!-- <div>désactiver la publication de mon article</div> -->
        <v-col>
          <v-row align="center" justify="center">
            <v-col align="center" class="pb-0">
              <v-btn
                class="button_armo"
                style="background-color: red; color: white"
                variant="flat"
                @click="showGenerationDataInfo = false"
              >
                Non
              </v-btn>
            </v-col>
            <v-col align="center" class="pb-0">
              <v-btn
                class="button_armo"
                style="background-color: green; color: white"
                variant="flat"
                @click="generateArticle"
              >
                Oui
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="showTimer" width="100%" max-width="700">
    <v-card color="" style="">
      <v-col align="center" class="pa-0">
        <div style="background-color: var(--C1)" class="py-3">
          <h2 style="color: white">Fréquence de publication</h2>
          <!-- <v-chip color="white" style="font-size: 14px" density="compact">
            Les publications vont du 1 au 28 de chaque mois
          </v-chip> -->
        </div>
        <div style="background-color: #dddddd">
          <v-col class="pa-0">
            <v-card class="pa-1" style="" variant="flat" color="transparent">
              <v-col>
                <v-row style="max-height: 450px; overflow: auto">
                  <v-col
                    v-for="elem in [1, 2, 3, 4, 5, 6, 7]"
                    :key="elem"
                    align="center"
                    cols="12"
                    class="pa-1"
                  >
                    <v-card
                      class="buttonReverse3"
                      @click="setArticleInterval(elem)"
                      style="border-radius: 5px !important"
                      align="left"
                    >
                      <v-col class="">
                        <v-row>
                          <v-col class="">
                            <div>
                              <v-icon> mdi-calendar </v-icon> Tous les
                              {{ elem != 1 ? elem : "" }} jours
                            </div>
                          </v-col>
                          <v-col align="right" class="">
                            <v-icon>mdi-approximately-equal</v-icon>
                            {{
                              Math.floor(30 / elem) >
                              groupInformation.article_month_generated_max
                                ? groupInformation.article_month_generated_max
                                : Math.floor(30 / elem) + 1
                            }}
                            articles / mois
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-card>
          </v-col>
        </div>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="selectedGeneratonData.modal" width="99%" max-width="600">
    <v-card v-if="selectedGeneratonData.data">
      <v-col class="pa-4 pb-1" align="center" style="font-size: 18px; font-weight: bold">
        Modification de la publication
        <v-btn
          @click="selectedGeneratonData.modal = false"
          style="position: absolute; right: 5px; top: 5px"
          icon="mdi-close"
          color="red"
          density="compact"
        ></v-btn>
      </v-col>
      <div
        v-if="selectedGeneratonData.data.isGenerate != 0"
        class="pa-4 py-0"
        style="color: red; font-size: 14px; font-weight: bold"
      >
        <!-- Article déjà généré, modification impossible utiliser une autre ligne de
          génération -->
        Les modifications d’un article déjà généré ne peuvent pas être effectuées depuis
        cet emplacement. Veuillez vous rendre dans votre calendrier éditorial pour les
        réaliser.
      </div>
      <div
        class="mt-3"
        v-if="
          selectedGeneratonData.data.isGenerate != 0 &&
          selectedGeneratonData.data.publicationId
        "
        style="width: 100%"
        align="center"
      >
        <v-btn
          v-if="selectedGeneratonData.data.isGenerate != 0"
          class="button"
          style="color: var(--C1); font-size: 14px; font-weight: bold"
          @click="showArticleFromId(selectedGeneratonData.data.publicationId)"
        >
          Visualiser mon article <v-icon class="ml-2">mdi-monitor-eye</v-icon>
        </v-btn>
      </div>

      <v-col v-if="false">
        <v-select
          class="no-dropdown-icon"
          :readonly="selectedGeneratonData.data.isGenerate != 0"
          :label="
            selectedGeneratonData.data.date == 0
              ? 'Aucune date planifiée'
              : 'Date de publication'
          "
          v-model="selectedGeneratonData.data.date"
          :items="[...Array(31).keys()].map((n) => n + 1)"
          :hide-spin-buttons="false"
          hide-details
        >
          <!-- : 'Publication le ' + selectedGeneratonData.data.date + ' de chaque mois' -->
          <template v-slot:selection="{ item }">
            <div>
              <!-- Jour de publication <v-chip density="compact">{{ item.title }}</v-chip>
              <br /> -->
              <div
                v-if="selectedGeneratonData.data.date == 0"
                style="color: red; font-weight: bold"
              >
                Aucune date planifiée
              </div>
              <span v-else style="color: var(--C1); font-weight: bold">
                <div
                  v-if="
                    selectedGeneratonData.data.publication_datetime &&
                    selectedGeneratonData.data.publication_datetime.length > 0
                  "
                >
                  {{ formatDate(selectedGeneratonData.data.publication_datetime)[0] }}
                  {{ formatDate(selectedGeneratonData.data.publication_datetime)[1] }}
                </div>
                <div v-else style="text-transform: capitalize">
                  <!-- Prochaine publication le {{ getPuclicationDate(item.title) }} -->
                  {{ getPuclicationDate(item.title) }}
                </div>
              </span>
            </div>
          </template>
        </v-select>
      </v-col>
      <v-col>
        <v-card color="#81C784" variant="flat">
          <v-textarea
            :readonly="selectedGeneratonData.data.isGenerate != 0"
            label="Requête cible"
            v-model="selectedGeneratonData.data.requeste"
            hide-details
            rows="1"
            auto-grow
            :clearable="!(selectedGeneratonData.data.isGenerate != 0)"
          ></v-textarea>
        </v-card>
      </v-col>

      <v-col v-if="groupInformation.web_site_data[selectedPlatformToShow]">
        <v-select
          :readonly="selectedGeneratonData.data.isGenerate != 0"
          label="Site de publication"
          item-title="label"
          v-model="selectedGeneratonData.data.site"
          item-value="uuid"
          :items="groupInformation.web_site_data[selectedPlatformToShow]"
          hide-details
          @update:model-value="selectedGeneratonData.data.idBlog = undefined"
        >
        </v-select>
      </v-col>
      <v-col
        v-if="
          selectedGeneratonData.data.site &&
          groupInformation.web_site_data[selectedPlatformToShow].find(
            (val) => val.uuid == selectedGeneratonData.data.site
          ) &&
          groupInformation.web_site_data[selectedPlatformToShow].find(
            (val) => val.uuid == selectedGeneratonData.data.site
          ).publication_platform_data &&
          groupInformation.web_site_data[selectedPlatformToShow].find(
            (val) => val.uuid == selectedGeneratonData.data.site
          ).publication_platform_data.length > 1
        "
      >
        <v-select
          :readonly="selectedGeneratonData.data.isGenerate != 0"
          return-object
          label="Blog de publication"
          item-title="label"
          :clearable="!(selectedGeneratonData.data.isGenerate != 0)"
          v-model="selectedGeneratonData.data.idBlog"
          :items="
            JSON.parse(
              groupInformation.web_site_data[selectedPlatformToShow].find(
                (val) => val.uuid == selectedGeneratonData.data.site
              ).publication_platform_data
            )
          "
          hide-details
        >
        </v-select>
      </v-col>
      <v-col
        v-if="
          groupInformation.templates.content &&
          groupInformation.templates.content.length != 0
        "
      >
        <v-select
          :readonly="selectedGeneratonData.data.isGenerate != 0"
          label="Rédacteur"
          item-title="title"
          item-value="idx"
          v-model="selectedGeneratonData.data.type"
          :items="groupInformation.templates.content"
          hide-details
        >
        </v-select>
      </v-col>
      <!-- <v-col
        v-if="
          groupInformation.templates.length.filter(
            (val) => val.platform == selectedPlatformToShow && val.show == true
          ).length > 1
        "
      >
        <v-select
          label="Longeur"
          class=""
          hide-details
          return-object
          v-model="selectedGeneratonData.data.length"
          :items="
            groupInformation.templates.length.filter(
              (val) => val.platform == selectedPlatformToShow && val.show == true
            )
          "
        ></v-select>
      </v-col> -->
      <!-- <v-col v-if="redacteurListe.filter((val) => val.show == true).length > 1">
        <v-select
          label="Rédacteur"
          class=""
          hide-details
          v-model="selectedGeneratonData.data.redacteur"
          :items="redacteurListe.filter((val) => val.show == true)"
        ></v-select>
      </v-col> -->
      <v-col>
        <v-row justify="center" align="center">
          <v-col cols="12" v-if="false">
            <v-switch
              :label="
                selectedGeneratonData.data.isActived == 1
                  ? 'Activer la publication mensuel automatique : Oui'
                  : 'Activer la publication mensuel automatique : Non'
              "
              density="compact"
              v-model="selectedGeneratonData.data.isActived"
              align="center"
              hide-details
              style="font-weight: bold"
              :style="{
                color: selectedGeneratonData.data.isActived == 1 ? '#388E3C' : 'red',
              }"
              inset
              :false-value="0"
              :true-value="1"
            ></v-switch>
          </v-col>
          <v-col
            cols="12"
            align="right"
            v-if="selectedGeneratonData.data.isGenerate == 0"
          >
            <v-btn
              @click="generateArticleVerif"
              class="button"
              :disabled="
                selectedGeneratonData.data.date == 0 ||
                getNbrLoadingArticle >= nbrMaxGeneration ||
                groupInformation.article_month_generated_max -
                  groupInformation.article_month_generated <=
                  0 ||
                selectedGeneratonData.data.requeste == undefined ||
                selectedGeneratonData.data.requeste.length == 0
              "
            >
              Générer maintenant
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col align="center" class="pt-0">
        <v-divider class="mb-4"></v-divider>
        <v-btn class="button" @click="updatePublication"> Enregistrer </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="isArticleSelected['value']" width="99%" max-width="500px">
    <v-card style="color: var(--C1)">
      <v-col
        align="center"
        style="font-weight: bold; position: relative"
        v-if="isArticleSelected['data']"
      >
        <!-- v-if="userInformation.admin_lvl >= 2" -->
        <v-btn
          color="red"
          style="position: absolute; left: 5px; top: 5px"
          class="button_armo"
          icon
          density="compact"
          @click="deleteProposition(isArticleSelected)"
        >
          <v-icon size="17"> mdi-trash-can </v-icon>
        </v-btn>

        <v-btn
          density="compact"
          color="red"
          style="position: absolute; right: 5px; top: 5px"
          icon="mdi-close"
          @click="isArticleSelected = { value: false, num: 1 }"
        >
        </v-btn>
        {{ isArticleSelected["data"].question }}
      </v-col>
      <v-col>
        <v-row justify="center" align="center">
          <v-col cols="auto"> Utiliser pour la prochaine publication N° </v-col>
          <v-col cols="auto" class="px-0" v-if="isArticleSelected['uuid']">
            <v-chip
              class=""
              style="
                width: 100px;
                border-radius: 50px;
                color: white;
                background-color: green;
              "
            >
              <v-select
                v-model="isArticleSelected['num']"
                style="color: white"
                :items="
                  [
                    ...Array(
                      autoPostData[isArticleSelected['uuid']]['nbr_progra'].length
                    ).keys(),
                  ].map((n) => n + 1)
                "
                density="compact"
                :hide-spin-buttons="false"
                hide-details
              >
                <!-- type="number" -->
                <template v-slot:selection="{ item }">
                  <div style="color: white; font-weight: bold">
                    {{ item.title }}
                  </div>
                </template>
              </v-select>
            </v-chip>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="isArticleSelected['num']" align="center">
        <v-btn class="button" @click="setArticleByIndex(autoPostData, isArticleSelected)">
          Valider
        </v-btn>
      </v-col>
    </v-card>
  </v-dialog>
  <v-dialog v-model="isSavePageOpen" width="auto">
    <v-card>
      <v-col>
        <v-row justify="center" align="center">
          <v-col
            cols="12"
            align="center"
            style="font-weight: bold; font-size: 21px"
            class="pb-0"
          >
            Valider mes modifications
          </v-col>
          <v-col align="right">
            <v-btn
              class="button_armo"
              style="background-color: red; color: white"
              variant="flat"
              @click="isSavePageOpen = false"
            >
              Non
            </v-btn>
          </v-col>
          <v-col align="left">
            <v-btn
              class="button_armo"
              style="background-color: green; color: white"
              variant="flat"
              @click="closeModalAndSave()"
            >
              OUi
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
  <!-- <v-col
    class="pb-2 pt-0"
    align="center"
    style="font-weight: bold; font-size: 25px; color: var(--C1)"
  >

    Publication mensuelle automatique
  </v-col> -->
  <v-card
    :class="updateCalendar == undefined ? 'mt-2' : ''"
    variant="flat"
    style="overflow: auto; background-color: #eeeeee; border: solid 1px lightgrey"
    :style="{ height: windowHeight - 177 + 'px' }"
  >
    <v-col>
      <v-row
        justify="center"
        align="center"
        :style="{ height: windowHeight - 180 + 'px' }"
      >
        <v-col align="center">
          <v-row justify="center" align="center">
            <v-col cols="12" md="10">
              <v-card color="transparent" variant="flat">
                <v-card
                  variant="flat"
                  style="
                    border: solid 1px lightgrey;
                    border-top-left-radius: 30px;
                    border-top-right-radius: 30px;
                    border-bottom-left-radius: 0px;
                    border-bottom-right-radius: 0px;
                    border-bottom: none;
                  "
                >
                  <v-col class="pa-6 pt-4">
                    <v-col
                      class="pt-0"
                      style="font-weight: bold; font-size: 20px; color: var(--C1)"
                    >
                      Génération d'article manuelle
                    </v-col>
                    <v-row align="center" justify="center">
                      <v-col cols="" class="pb-0">
                        <v-card variant="flat" style="border: solid 1px lightgrey">
                          <v-text-field
                            label="Requête cible de votre article"
                            hide-details
                            v-model="manuelArticle.data.requeste"
                          ></v-text-field>
                        </v-card>
                      </v-col>
                      <v-col cols="auto" class="pb-0">
                        <v-btn class="button" @click="generateArticleVerifNow">
                          Générer
                        </v-btn>
                      </v-col>
                      <v-col cols="12" class="py-0 px-1">
                        <v-checkbox
                          label="Afficher les détails de publication"
                          value="data"
                          v-model="showManualGenerationDetails"
                          hide-details
                          multiple
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" class="pt-0">
                        <v-expansion-panels v-model="showManualGenerationDetails">
                          <v-expansion-panel
                            style=""
                            class=""
                            density="compact"
                            value="data"
                          >
                            <v-expansion-panel-text>
                              <v-col
                                cols="12"
                                class="px-0"
                                v-if="
                                  groupInformation.web_site_data[selectedPlatformToShow]
                                "
                              >
                                <v-card variant="flat">
                                  <v-select
                                    label="Site de publication"
                                    item-title="label"
                                    v-model="manuelArticle.data.site"
                                    item-value="uuid"
                                    :items="
                                      groupInformation.web_site_data[
                                        selectedPlatformToShow
                                      ]
                                    "
                                    hide-details
                                    @update:model-value="
                                      manuelArticle.data.idBlog = undefined
                                    "
                                  >
                                  </v-select>
                                </v-card>
                              </v-col>
                              <v-col
                                class="px-0"
                                cols="12"
                                v-if="
                                  manuelArticle.data &&
                                  manuelArticle.data.site &&
                                  groupInformation.web_site_data[
                                    selectedPlatformToShow
                                  ].find((val) => val.uuid == manuelArticle.data.site) &&
                                  groupInformation.web_site_data[
                                    selectedPlatformToShow
                                  ].find((val) => val.uuid == manuelArticle.data.site)
                                    .publication_platform_data &&
                                  groupInformation.web_site_data[
                                    selectedPlatformToShow
                                  ].find((val) => val.uuid == manuelArticle.data.site)
                                    .publication_platform_data.length > 1
                                "
                              >
                                <v-card variant="flat">
                                  <v-select
                                    return-object
                                    label="Blog de publication"
                                    item-title="label"
                                    :clearable="!(manuelArticle.data.isGenerate != 0)"
                                    v-model="manuelArticle.data.idBlog"
                                    :items="
                                      JSON.parse(
                                        groupInformation.web_site_data[
                                          selectedPlatformToShow
                                        ].find(
                                          (val) => val.uuid == manuelArticle.data.site
                                        ).publication_platform_data
                                      )
                                    "
                                    hide-details
                                  >
                                  </v-select>
                                </v-card>
                              </v-col>
                              <v-col
                                class="px-0"
                                cols="12"
                                v-if="
                                  groupInformation.templates.content &&
                                  groupInformation.templates.content.length != 0
                                "
                              >
                                <v-card variant="flat">
                                  <v-select
                                    label="Rédacteur"
                                    item-title="title"
                                    item-value="idx"
                                    v-model="manuelArticle.data.type"
                                    :items="groupInformation.templates.content"
                                    hide-details
                                  >
                                  </v-select>
                                </v-card>
                              </v-col>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card>
                <div
                  class="px-4 py-3"
                  style="
                    background-color: white;
                    border-right: solid 1px lightgrey;
                    border-left: solid 1px lightgrey;
                  "
                ></div>
                <div
                  style="
                    background-color: white;
                    border-right: solid 1px lightgrey;
                    border-left: solid 1px lightgrey;
                    border-top: solid 1px lightgrey;
                  "
                >
                  <v-col
                    cols="12"
                    v-if="
                      autoPostData &&
                      selectedSiteToShow &&
                      autoPostData[selectedSiteToShow.uuid]
                    "
                    style="position: relative"
                  >
                    <div
                      class="mb-3 mt-6"
                      style="font-weight: bold; font-size: 20px; color: var(--C1)"
                    >
                      Liste des publications automatique mensuelle
                      <div
                        class="mb-3"
                        style="font-weight: bold; font-size: 20px; color: var(--C1)"
                      >
                        <v-btn
                          :density="isMobile ? 'compact' : 'default'"
                          variant="flat"
                          class="button2"
                          @click="setArticleInterval(undefined)"
                          style="
                            top: 8px;
                            right: 15px;
                            position: absolute;
                            text-transform: none;
                            border-radius: 30px !important;
                            background-color: red;
                            color: white;
                          "
                          align="left"
                        >
                          Désactiver la publication auto
                        </v-btn>
                      </div>

                      <div
                        style="font-size: 13px; color: red"
                        v-if="
                          groupInformation.article_month_generated_max != getSlotToShow &&
                          getSlotToShow.length == 0
                        "
                      >
                        Publication automatique désactivé
                      </div>
                      <div
                        style="font-size: 13px; color: red"
                        v-else-if="
                          groupInformation.article_month_generated_max !=
                          getSlotToShow.length
                        "
                      >
                        (
                        {{ getSlotToShow.length }}
                        programmé(s) / {{ groupInformation.article_month_generated_max }}
                        disponible(s))
                      </div>
                    </div>
                    <v-col v-if="getSlotToShow.length > 0">
                      <v-row align="center">
                        <v-col
                          cols="auto"
                          v-for="(elem, idx) in getSlotToShow.sort(
                            (a, b) => a.date - b.date
                          )"
                          :key="idx"
                        >
                          <v-chip
                            v-if="elem.date != 0 && elem.isActived != 0"
                            class="ma-0 py-0"
                            style="font-size: 14px; cursor: pointer"
                            color="var(--C1)"
                            @click="editPubicationDate(elem)"
                          >
                            Publi le
                            <span class="mx-1" style="font-weight: bold; color: red">{{
                              elem.date
                            }}</span>
                            de chaque mois
                          </v-chip>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-0 px-1">
                      <v-checkbox
                        label="Afficher les fréquences de publication proposée"
                        value="generation"
                        v-model="showManualGenerationDetails"
                        hide-details
                        multiple
                      ></v-checkbox>
                      <v-col cols="12" class="pt-0">
                        <v-expansion-panels v-model="showManualGenerationDetails">
                          <v-expansion-panel
                            style=""
                            class=""
                            density="compact"
                            value="generation"
                          >
                            <v-expansion-panel-text>
                              <div class="px-1">
                                <v-col class="" style="">
                                  <v-col>
                                    <v-row justify="center" align="center">
                                      <v-col
                                        v-for="elem in [0, 1, 2, 3, 4, 5, 6, 7]"
                                        :key="elem"
                                        align="center"
                                        cols="auto"
                                        class="pa-1"
                                      >
                                        <v-card
                                          variant="flat"
                                          class="button2 px-5 py-2"
                                          @click="setArticleInterval(elem)"
                                          style="border-radius: 30px !important"
                                          :style="
                                            elem == 0
                                              ? 'background-color:#4CAF50;color:white;'
                                              : 'background-color:#e0e5eb;color: var(--C1),'
                                          "
                                          align="left"
                                        >
                                          <div v-if="elem == 0">Recommandée</div>
                                          <div v-else>
                                            <div style="font-size: 14px">
                                              Tous les
                                              {{ elem != 1 ? elem : "" }} jours
                                            </div>
                                            <div
                                              v-if="!isMobile"
                                              style="font-size: 12px; font-weight: normal"
                                              align="center"
                                            >
                                              <v-icon>mdi-approximately-equal</v-icon>
                                              {{
                                                Math.floor(30 / elem) >=
                                                groupInformation.article_month_generated_max
                                                  ? groupInformation.article_month_generated_max
                                                  : Math.floor(30 / elem) + 1
                                              }}
                                              par mois
                                            </div>
                                          </div>
                                        </v-card>
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-col>
                              </div>
                            </v-expansion-panel-text>
                          </v-expansion-panel>
                        </v-expansion-panels>
                        <!-- <v-expansion-panels v-model="showManualGenerationDetails">
                          <v-expansion-panel
                            style=""
                            class=""
                            density="compact"
                            value="generation"
                          >
                            <div class="px-1">
                              <v-col class="" style="">
                                <div
                                  class="mb-3"
                                  style="
                                    font-weight: bold;
                                    font-size: 20px;
                                    color: var(--C1);
                                  "
                                >
                                  <v-btn
                                    :density="isMobile ? 'compact' : 'default'"
                                    variant="flat"
                                    class="button2"
                                    @click="setArticleInterval(undefined)"
                                    style="
                                      top: 8px;
                                      right: 15px;
                                      position: absolute;
                                      text-transform: none;
                                      border-radius: 30px !important;
                                      background-color: red;
                                      color: white;
                                    "
                                    align="left"
                                  >
                                    Désactiver
                                  </v-btn>
                                </div>
                                <v-col>
                                  <v-row justify="center" align="center">
                                    <v-col
                                      v-for="elem in [1, 2, 3, 4, 5, 6, 7]"
                                      :key="elem"
                                      align="center"
                                      cols="auto"
                                      class="pa-1"
                                    >
                                      <v-card
                                        class="button3 px-5 py-2"
                                        @click="setArticleInterval(elem)"
                                        style="border-radius: 30px !important"
                                        align="left"
                                      >
                                        <div style="font-size: 14px">
                                          Tous les
                                          {{ elem != 1 ? elem : "" }} jours
                                        </div>
                                        <div
                                          v-if="!isMobile"
                                          style="font-size: 12px"
                                          align="center"
                                        >
                                          <v-icon>mdi-approximately-equal</v-icon>
                                          {{
                                            Math.floor(30 / elem) >=
                                            groupInformation.article_month_generated_max
                                              ? groupInformation.article_month_generated_max
                                              : Math.floor(30 / elem) + 1
                                          }}
                                          par mois
                                        </div>
                                      </v-card>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-col>
                            </div>
                          </v-expansion-panel>
                        </v-expansion-panels> -->
                      </v-col>
                    </v-col>
                  </v-col>
                </div>
                <v-card
                  variant="flat"
                  style="
                    border-top: none;
                    border: solid 1px lightgrey;
                    border-bottom-left-radius: 30px;
                    border-bottom-right-radius: 30px;
                    border-top-left-radius: 0px;
                    border-top-right-radius: 0px;
                  "
                >
                  <v-col align="right" class="">
                    <v-btn
                      @click="showFullEdit = true"
                      class="button2"
                      variant="flat"
                      color="#4CAF50"
                      style="color: white"
                    >
                      Options avancées
                    </v-btn>
                  </v-col>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-card>
  <v-snackbar
    v-model="snackData.model"
    :color="snackData.color"
    timeout="5000"
    style="font-weight: bold"
  >
    {{ snackData.label }}
  </v-snackbar>
</template>

<script>
import engine from "@/core/index";
// import BasicHelpBox from "@/components/basic/basic-help-box.vue";
import moment from "moment";
import editShopifyArticle from "@/components/blog/blog-article-edition.vue";
import Vue3EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";
import { v4 as uuidv4 } from "uuid";

export default {
  props: {
    userInformation: {},
    blogListe: {},
    nbrMaxGeneration: {},
    getNbrLoadingArticle: {},
    getSquedueldata: { type: Function },
    updateData: { type: Function },
    updateCalendar: { type: Function },
    windowHeight: {},
    groupInformation: {},
  },
  components: {
    // BasicHelpBox,
    editShopifyArticle,
    Vue3EasyDataTable,
  },
  watch: {
    async selectedSiteToShow(valSite) {
      this.selectedTheme = undefined;
      if (
        this.groupInformation["proposition_data"] &&
        this.groupInformation["proposition_data"].length > 0
      )
        this.selectedKeyWords = this.groupInformation["proposition_data"].find(
          (val) => val.site_id == valSite.uuid
        );
    },
    selectedKeyWords() {
      this.selectedTheme = undefined;
      if (
        this.selectedKeyWords &&
        this.selectedKeyWords.results &&
        this.selectedKeyWords.results[0]
      )
        this.selectedTheme = this.selectedKeyWords.results[0];
    },
  },
  data() {
    return {
      modalData: {},
      modalIsOpen: {},
      showManualGenerationDetails: [],
      showGenerationDataInfoNow: false,
      manuelArticle: { data: {} },
      showFullEdit: false,
      snackData: {},
      showGenerationDataInfo: false,
      showTimer: false,
      selectedGeneratonData: {
        modal: false,
        data: {},
      },
      selectedPlatformToShow: "article_seo",
      platformToShow: ["article_seo"],
      selectedSiteToShow: undefined,
      selectedTheme: {},
      selectedKeyWords: undefined,
      blogToPublish: {},
      basicData: undefined,
      globalActivation: {},
      isArticleSelected: {
        // num: 1,
      },
      selectedKeyWordData: {},
      selectedThemeData: {},
      autoPostData: {},
      isSavePageOpen: false,
      daysToPubli: [1, 31],
      programationData: {},
    };
  },
  computed: {
    getSlotToShow() {
      return this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"].filter(
        (val) => val.site == this.selectedSiteToShow.uuid && val.isActived == 1
      );

      // .filter(
      //   (val) => val.site == this.selectedSiteToShow.uuid && val.isActived == 1
      // ).sort((a, b) => a.date - b.date)

      //   return this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"].filter(
      //     (val) => val.site == this.selectedSiteToShow.uuid && val.isActived == 1
      //   ).sort((a, b) => a.date - b.date);
    },
    getDate() {
      return moment().format("MMMM YYYY");
    },
    getCurrentDateDayNum() {
      return parseInt(moment().format("D"));
    },
    getProgrammedArticleTitle() {
      return this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"]
        .map((val) => val.requeste)
        .filter((val2) => val2.length > 0);
    },
    getHeaders() {
      let tab = [
        {
          // text: "Jour de publication (entre 1 et 28)",
          text: "Jour de publication",
          value: "date",
          sortable: true,
          width: 205,
        },
        {
          text: "Requête cible (de la prochaine publication)",
          value: "requeste",
          sortable: true,
          width: "100%",
        },
        // {
        //   text: "Générer maintenant",
        //   value: "generatetNow",
        //   sortable: true,
        // },
        {
          text: "Statut",
          value: "isGenerate",
          sortable: true,
          width: 100,
        },
        {
          text: "Publié",
          value: "isPosted",
          sortable: true,
          width: 100,
        },
        // {
        //   text: "Publi activée",
        //   value: "isActived",
        //   sortable: true,
        //   width: 100,
        // },
      ];

      return tab;
    },
    isBigEnougth() {
      return this.$vuetify.display.xlAndUp;
    },
    isMobile() {
      return this.$vuetify.display.mobile;
    },
  },
  methods: {
    getDay(date) {
      let month = moment().format("MM");
      let year = moment().format("YYYY");

      let finalDate = month + "/" + date + "/" + year;

      if (this.isMobile)
        return [
          moment(finalDate).format("ddd DD/MM/YYYY").replaceAll(".", ""),
          undefined,
        ];
      else
        return [
          moment(finalDate).format("ddd D MMM").replaceAll(".", ""),
          moment(finalDate).format("YYYY").replaceAll(".", ""),
        ];
    },
    setNewAutoPubliDate(date) {
      for (let i = 0; i < this.platformToShow.length; i++) {
        let platform = this.platformToShow[i];
        let siteListe = this.groupInformation.web_site_data[platform];

        for (let b = 0; b < siteListe.length; b++) {
          let site = siteListe[b];

          if (this.autoPostData[site.uuid] && this.autoPostData[site.uuid].nbr_progra) {
            let finded = this.autoPostData[site.uuid].nbr_progra.findIndex(
              (val) => val.uuid == this.modalIsOpen["editRecuDate"].data.uuid
            );

            if (finded != -1) {
              this.autoPostData[site.uuid].nbr_progra[finded].date = date;
            }
          }
        }
      }

      this.modalIsOpen["editRecuDate"] = {};
      this.closeModalAndSave();
    },
    editPubicationDate(elem) {
      this.modalIsOpen["editRecuDate"] = {
        isOpen: true,
        data: elem,
      };
    },
    repartirJours(nbJours) {
      let duree = 31;
      let result = [];

      if (nbJours <= 0 || duree <= 0) return result;

      if (nbJours <= duree) {
        // Cas où on répartit uniformément dans la plage
        let interval = duree / nbJours;
        for (let i = 0; i < nbJours; i++) {
          result.push(Math.round(1 + i * interval));
        }
      } else {
        // Cas où on doit répéter des jours
        let repetitions = Math.floor(nbJours / duree);
        let reste = nbJours % duree;

        for (let jour = 1; jour <= duree; jour++) {
          for (let r = 0; r < repetitions; r++) {
            result.push(jour);
          }
          if (jour <= reste) {
            result.push(jour);
          }
        }
      }

      return result;
    },
    formatDate(date) {
      if (this.isMobile)
        return [moment(date).format("ddd DD/MM/YYYY").replaceAll(".", ""), ""];
      else
        return [
          moment(date).format("ddd D MMM").replaceAll(".", ""),
          moment(date).format("YYYY").replaceAll(".", ""),
        ];
    },
    updatePostData() {
      console.log("updatePostData");
      this.initPostData();
    },
    showArticleFromId(id) {
      let that = this;
      engine.get_user_article_soft_by_tokens(id, function (data) {
        if (data.state == 200) {
          that.modalData = { data: data.data[0], publication_id: id };
          console.log("modalData", that.modalData);
          that.modalIsOpen["editShopifyArticle"] = true;
        }
      });
    },
    setManualInfo() {
      // let that = this
      this.manuelArticle.data = {};

      if (this.groupInformation.web_site_data[this.selectedPlatformToShow]) {
        this.manuelArticle.data.site = this.groupInformation.web_site_data[
          this.selectedPlatformToShow
        ][0].uuid;
      }

      if (
        this.manuelArticle.data.site &&
        this.groupInformation.web_site_data[this.selectedPlatformToShow].find(
          (val) => val.uuid == this.manuelArticle.data.site
        ) &&
        this.groupInformation.web_site_data[this.selectedPlatformToShow].find(
          (val) => val.uuid == this.manuelArticle.data.site
        ).publication_platform_data
      ) {
        this.manuelArticle.data.idBlog = JSON.parse(
          this.groupInformation.web_site_data[this.selectedPlatformToShow].find(
            (val) => val.uuid == this.manuelArticle.data.site
          ).publication_platform_data
        );
      }

      if (
        this.groupInformation.templates.content &&
        this.groupInformation.templates.content.length != 0
      ) {
        this.manuelArticle.data.type = this.groupInformation.templates.content[0];
      }
    },
    sendNewConfig(newConfig) {
      let that = this;
      newConfig = JSON.parse(JSON.stringify(newConfig));

      for (const [key, value] of Object.entries(newConfig)) {
        if (typeof value == "object") {
          newConfig[key] = JSON.stringify(value);
        }
      }

      engine.update_group_config(this.groupInformation.id, newConfig, function () {
        that.updateData();
      });
    },
    deleteProposition(proposition) {
      let findexIndex = this.selectedTheme.results.findIndex(
        (val) => val.uuid == proposition.data.uuid
      );
      this.selectedTheme.results.splice(findexIndex, 1);
      // this.isArticleSelected["value"] = false;
      this.isArticleSelected = {};
      this.updateProposition();
    },
    updateProposition() {
      let questionsListe = {};
      for (let i = 0; i < this.groupInformation.proposition_data.length; i++) {
        let elem = this.groupInformation.proposition_data[i];
        for (let a = 0; a < elem.results.length; a++) {
          let subElem = elem.results[a];
          let questions = subElem.results.map((val) => val.questionVerified);

          if (questionsListe[elem.site_id] == undefined)
            questionsListe[elem.site_id] = [];
          questionsListe[elem.site_id] = questionsListe[elem.site_id].concat(questions);
        }
      }

      engine.set_proposition_questions(
        JSON.stringify(questionsListe),
        this.groupInformation.id,
        function () {}
      );

      engine.set_proposition_data(
        JSON.stringify(this.groupInformation["proposition_data"]),
        this.groupInformation.id,
        function () {}
      );
    },
    updatePublication() {
      if (
        this.selectedGeneratonData &&
        this.selectedGeneratonData.data &&
        this.selectedGeneratonData.data.uuid
      ) {
        let index = this.autoPostData[this.selectedSiteToShow.uuid][
          "nbr_progra"
        ].findIndex((val) => val.uuid == this.selectedGeneratonData.data.uuid);

        this.autoPostData[this.selectedSiteToShow.uuid]["nbr_progra"][
          index
        ] = this.selectedGeneratonData.data;
        this.selectedGeneratonData = {
          modal: false,
          data: undefined,
        };
      }
      this.closeModalAndSave();
    },
    editPublication(data) {
      console.log("data", data.publicationId);

      if (data.publicationId && data.publicationId.length > 0) {
        // if (data.isGenerate == 1) {
        //   this.snackData = {
        //     model: true,
        //     color: "red",
        //     label:
        //       "Il n'est pas possible de modifier la requête cible d’un article déjà généré",
        //   };
        // } else 
        this.showArticleFromId(data.publicationId);
      } else {
        if (Object.entries(this.isArticleSelected).length == 0)
          this.selectedGeneratonData = {
            modal: true,
            data,
          };
        else {
          if (data.isGenerate == 1) {
            this.snackData = {
              model: true,
              color: "red",
              label:
                "Il n'est pas possible de modifier la requête cible d’un article déjà généré",
            };
          } else this.setArticleByIndex(this.autoPostData, this.isArticleSelected, data);
        }
      }
    },
    initPostData() {
      let that = this;
      engine.get_basic_data(function (basic_data) {
        if (basic_data.state == 200) {
          that.basicData = {
            // redacteur: JSON.parse(basic_data.data[0].redacteur),
            // settings: JSON.parse(basic_data.data[0].settings),
            templates: JSON.parse(basic_data.data[0].templates),
            // web_site_data: JSON.parse(basic_data.data[0].web_site_data),
          };

          if (
            that.groupInformation &&
            that.groupInformation.templates.content.length == 0
          ) {
            that.groupInformation.templates.content = that.basicData.templates;
            that.sendNewConfig(that.groupInformation);
          }

          // let redacteurBasic = that.basicData.redacteur.filter((val) => val.show == true);

          // let redacteurGroupe = that.groupInformation.templates.redacteur.filter(
          //   (val) => val.show == true
          // );

          // that.redacteurListe = redacteurGroupe.concat(redacteurBasic);
        }
        engine.get_auto_post_data(that.groupInformation.id, function (data) {
          if (data.state == 200) {
            let auto_post_data = data.data[0];
            if (auto_post_data.auto_post_data) {
              that.autoPostData = JSON.parse(auto_post_data.auto_post_data);
              that.updateAutoPostData();
            }
          } else {
            that.autoPostData = {};
          }
          that.verifGenerationListeSize();
        });
      });
    },
    updateAutoPostData() {
      let siteListe = [];
      for (const data of Object.values(this.groupInformation.web_site_data)) {
        siteListe = siteListe.concat(data);
      }

      for (const ListeProgramation of Object.values(this.autoPostData)) {
        if (ListeProgramation && ListeProgramation.nbr_progra)
          for (let i = 0; i < ListeProgramation.nbr_progra.length; i++) {
            let prog = ListeProgramation.nbr_progra[i];

            // if (
            //   prog.redacteur &&
            //   this.redacteurListe.find(
            //     (val) => val.idx == prog.redacteur.idx && val.show == true
            //   )
            // )
            //   prog.redacteur = this.redacteurListe.find(
            //     (val) => val.idx == prog.redacteur.idx && val.show == true
            //   );
            // else
            //   prog.redacteur = this.redacteurListe.find(
            //     (val) => val.show == true && val.default_selected == true
            //   );

            // if (
            //   this.groupInformation.templates.length.find(
            //     (val) => val.idx == prog.length.idx && val.show == true
            //   )
            // )
            //   prog.length = this.groupInformation.templates.length.find(
            //     (val) => val.idx == prog.length.idx && val.show == true
            //   );
            // else
            //   prog.length = this.groupInformation.templates.length.find(
            //     (val) => val.show == true && val.default_selected == true
            //   );

            if (siteListe.find((val) => val.uuid == prog.site.uuid)) {
              let findedSite = siteListe.find((val) => val.uuid == prog.site.uuid);
              if (findedSite)
                prog.site = siteListe.find((val) => val.uuid == prog.site.uuid).uuid;
            }

            if (
              prog.site.publication_platform_data &&
              prog.site.publication_platform_data.length > 0
            ) {
              let publication_platform_data = JSON.parse(
                prog.site.publication_platform_data
              );
              prog.idBlog = publication_platform_data[0];
            }

            // if (
            //   this.blogToPublish[prog.site.platform] &&
            //   this.blogToPublish[prog.site.platform][prog.site.uuid]
            // ) {
            //   let BlogToPublish = [];
            //   BlogToPublish = this.blogToPublish[prog.site.platform][prog.site.uuid];
            //   if (BlogToPublish.length > 0) prog.idBlog = BlogToPublish[0];
            // }

            if (
              this.groupInformation.templates.content.find(
                (val) => val.idx == prog.type.idx && val.show == true
              )
            )
              prog.type = this.groupInformation.templates.content.find(
                (val) => val.idx == prog.type.idx && val.show == true
              ).idx;
          }
      }
    },
    getPuclicationDate(dayNumber) {
      const today = moment(); // date actuelle
      const currentDay = today.date();

      // Si le jour est dans le futur ce mois-ci
      if (dayNumber > currentDay) {
        const thisMonthDate = moment().date(dayNumber);
        if (thisMonthDate.isValid()) {
          return thisMonthDate.format("LL");
        }
      }

      // Sinon on prend le mois prochain
      const nextMonthDate = moment().add(1, "month").date(dayNumber);
      if (nextMonthDate.isValid()) {
        return nextMonthDate.format("LL");
      }

      // Si la date est invalide (ex: 31 février), on ajuste au dernier jour valide
      const lastValidDay = moment().add(1, "month").endOf("month").date();
      const adjustedDate = moment()
        .add(1, "month")
        .date(Math.min(dayNumber, lastValidDay));
      return adjustedDate.format("LL");
    },
    changeActivation(val, tab) {
      for (let i = 0; i < tab.length; i++) {
        tab[i].isActived = val;
      }
      this.closeModalAndSave();
    },
    verifGenerationListeSize() {
      for (let i = 0; i < this.platformToShow.length; i++) {
        let platform = this.platformToShow[i];
        let siteListe = this.groupInformation.web_site_data[this.selectedPlatformToShow];

        for (let b = 0; b < siteListe.length; b++) {
          let site = siteListe[b];

          if (!this.autoPostData) this.autoPostData = {};
          if (!this.autoPostData[site.uuid])
            this.autoPostData[site.uuid] = { nbr_progra: [] };

          if (this.autoPostData[site.uuid] && this.autoPostData[site.uuid].nbr_progra) {
            let nbrProgrammation = this.autoPostData[site.uuid].nbr_progra.length;
            let nbrMax = this.groupInformation.article_month_generated_max;

            if (nbrProgrammation < nbrMax) {
              while (nbrProgrammation < nbrMax) {
                this.addGeneration(platform, site.uuid, "nbr_progra", site);
                nbrProgrammation += 1;
              }
            } else if (nbrProgrammation > nbrMax) {
              while (nbrProgrammation > nbrMax) {
                this.removeGeneration(site.uuid, "nbr_progra");
                nbrProgrammation -= 1;
              }
            }
          }
        }
      }
      this.closeModalAndSave();
    },
    setArticleInterval(interval) {
      let reco = undefined;

      if (interval == 0) {
        reco = this.repartirJours(this.groupInformation.article_month_generated_max);
      }

      for (let i = 0; i < this.platformToShow.length; i++) {
        let platform = this.platformToShow[i];
        let siteListe = this.groupInformation.web_site_data[platform];

        for (let b = 0; b < siteListe.length; b++) {
          let site = siteListe[b];

          if (this.autoPostData[site.uuid] && this.autoPostData[site.uuid].nbr_progra) {
            let start = 1;

            for (let a = 0; a < this.autoPostData[site.uuid].nbr_progra.length; a++) {
              let findedDate = undefined;

              if (reco && reco.length > 0) {
                findedDate = reco[a];
              } else {
                findedDate = start;
              }

              if (start <= 31 && interval != undefined) {
                // if (this.autoPostData[site.uuid].nbr_progra[a].isGenerate == 1) {
                this.autoPostData[site.uuid].nbr_progra[a].date = String(findedDate);
                this.autoPostData[site.uuid].nbr_progra[a].isActived = 1;
                start += interval; // au lieu de cnt * interval
                // } else {
                //   this.autoPostData[site.uuid].nbr_progra[a].date = String(start);
                //   this.autoPostData[site.uuid].nbr_progra[a].isActived = 1;
                //   start += interval; // au lieu de cnt * interval
                // }
              } else {
                // if (this.autoPostData[site.uuid].nbr_progra[a].isGenerate == 1) {
                this.autoPostData[site.uuid].nbr_progra[a].date = String(0);
                this.autoPostData[site.uuid].nbr_progra[a].isActived = 0;
                start += interval; // au lieu de cnt * interval
                // } else {
                //   this.autoPostData[site.uuid].nbr_progra[a].date = String(0);
                //   this.autoPostData[site.uuid].nbr_progra[a].isActived = 0;
                //   start += interval; // au lieu de cnt * interval
                // }
              }
            }
          }
        }
      }

      // for (let i = 0; i < this.platformToShow.length; i++) {
      //   let platform = this.platformToShow[i];
      //   let siteListe = this.groupInformation.web_site_data[platform];

      //   for (let b = 0; b < siteListe.length; b++) {
      //     let site = siteListe[b];

      //     if (this.autoPostData[site.uuid] && this.autoPostData[site.uuid].nbr_progra) {
      //       let cnt = 1;

      //       this.autoPostData[site.uuid].nbr_progra[0].date = String(1);
      //       this.autoPostData[site.uuid].nbr_progra[0].isActived = 1;
      //       for (let a = 0; a < this.autoPostData[site.uuid].nbr_progra.length; a++) {
      //         if (cnt * interval <= 28) {
      //           this.autoPostData[site.uuid].nbr_progra[a].date = String(cnt * interval);
      //           this.autoPostData[site.uuid].nbr_progra[a].isActived = 1;
      //         } else {
      //           this.autoPostData[site.uuid].nbr_progra[a].date = String(0);
      //           this.autoPostData[site.uuid].nbr_progra[a].isActived = 0;
      //         }
      //         cnt += 1;
      //       }
      //     }
      //   }
      // }
      this.showTimer = false;
      this.closeModalAndSave();
    },

    setArticleProposal() {
      let questionListe = this.groupInformation.proposition_questions;

      for (let i = 0; i < this.platformToShow.length; i++) {
        let platform = this.platformToShow[i];
        let siteListe = this.groupInformation.web_site_data[platform];

        for (let b = 0; b < siteListe.length; b++) {
          let site = siteListe[b];
          let questions = questionListe[site.uuid];

          if (this.autoPostData[site.uuid] && this.autoPostData[site.uuid].nbr_progra) {
            let usedIndexes = new Set(); // ← Empêche les doublons de questions

            for (let a = 0; a < this.autoPostData[site.uuid].nbr_progra.length; a++) {
              let progra = this.autoPostData[site.uuid].nbr_progra[a];

              if (!progra.requeste || progra.requeste.length === 0) {
                // Si on a utilisé toutes les questions, on ne peut plus en assigner une unique
                if (usedIndexes.size >= questions.length) break;

                let index;
                do {
                  index = Math.floor(Math.random() * questions.length);
                } while (usedIndexes.has(index));

                usedIndexes.add(index);
                progra.requeste = questions[index];
              }
            }
          }
        }
      }

      this.closeModalAndSave();
    },
    generateArticleVerif() {
      this.showGenerationDataInfo = true;
    },
    generateArticleVerifNow() {
      this.showGenerationDataInfoNow = true;
    },
    generateArticle() {
      // updatePublication
      this.selectedGeneratonData.data.isGenerate = 1;
      let that = this;
      let today = new Date();
      let month = today.getMonth() + 1; // Les mois commencent à 0, donc on ajoute 1
      let year = today.getFullYear();
      let dateDay = this.selectedGeneratonData.data.date;
      let publication_id = uuidv4();
      this.showGenerationDataInfo = false;

      if (today.getDate() > dateDay) {
        month = month + 1;
        if (month == 13) {
          month = 1;
          year = year + 1;
        }
      }

      if (month < 10) month = "0" + month;
      if (dateDay < 10) dateDay = "0" + dateDay;

      let randomNumber = Math.floor(Math.random() * (18 - 12 + 1)) + 12;
      let date = month + "/" + dateDay + "/" + year;

      let obj = {
        onlyPlan: "false",
        chatgptQuestion: { title: this.selectedGeneratonData.data["requeste"] },
        dataForm: {
          publication_date: { value: date },
          publication_time: { value: randomNumber + ":00" },
          publication_datetime: { value: "" },
          publication_id: { value: publication_id },
          post_compte_id: { value: "" },
          isPosted: { value: 0 },
          file_ids: { value: [] },
          user: {
            value: {
              lastname: "Jauris",
              firstname: "BOT",
              user_id: "0000000000",
              group_id: this.groupInformation.id,
            },
          },
          group: {
            value: {
              id: this.groupInformation.id,
              assistant_id: this.groupInformation.assistant_id,
              album_data: this.groupInformation.album_data,
            },
          },
          thread: { value: "" },
          tags: { value: "" },
          metadata: { value: "" },
          optionalContent: { value: { content: {} } },
        },
      };
      obj["selectedTemplate"] = {};

      obj["selectedTemplate"]["content"] = this.groupInformation.templates.content.find(
        (val) => val.idx == this.selectedGeneratonData.data["type"]
      );

      if (obj["selectedTemplate"]["content"] == undefined)
        obj["selectedTemplate"]["content"] = this.basicData.templates.content.find(
          (val) => val.idx == this.selectedGeneratonData.data["type"]
        );

      if (
        this.groupInformation.web_site_data &&
        this.groupInformation.web_site_data[obj["selectedTemplate"]["content"].type]
      )
        obj["selectedSite"] = this.groupInformation.web_site_data[
          obj["selectedTemplate"]["content"].type
        ].find((val) => val.uuid == this.selectedGeneratonData.data["site"]);

      //  {
      //     content: this.groupInformation.templates.content.find(
      //       (val) => val.idx == this.selectedGeneratonData.data["type"]
      //     ),
      //     // length: this.groupInformation.templates.length.find(
      //     //   (val) => val.idx == this.selectedGeneratonData.data["length"].idx
      //     // ),
      //     // redacteur: this.redacteurListe.find(
      //     //   (val) => val.idx == this.selectedGeneratonData.data["redacteur"].idx
      //     // ),
      //   },
      //   selectedSite: this.groupInformation.web_site_data[
      //     this.selectedGeneratonData.data["type"].type
      //   ].find((val) => val.uuid == this.selectedGeneratonData.data["site"]),

      if (
        this.selectedGeneratonData.data.idBlog &&
        this.selectedGeneratonData.data.idBlog.id
      )
        obj.dataForm["post_compte_id"] = {
          value: { id: this.selectedGeneratonData.data.idBlog.id },
        };

      that.selectedGeneratonData.data.isGenerate = 1;
      that.selectedGeneratonData.data.publicationId = publication_id;

      that.updatePublication();

      if (that.userInformation.klaviyo && that.userInformation.klaviyo.length > 0) {
        obj["klaviyo"] = that.userInformation.klaviyo;
        engine.set_klaviyo_event(
          that.userInformation.klaviyo,
          "Génération manuelle d'un article : " + obj.chatgptQuestion.title
        );
      }

      // console.log("obj", obj);

      if (
        obj.selectedTemplate.content == undefined ||
        obj.selectedTemplate.content.type == undefined ||
        obj.selectedTemplate.content.type == "article_seo"
      ) {
        engine.creat_shopify_article_from_server(obj, function () {
          that.getSquedueldata();
        });

        setTimeout(function () {
          that.updateData();
        }, 2000);
      }
    },
    generateArticleNow() {
      // updatePublication
      // manuelArticle

      this.manuelArticle.data.isGenerate = 1;
      let that = this;
      let today = new Date();
      let month = today.getMonth() + 1; // Les mois commencent à 0, donc on ajoute 1
      let year = today.getFullYear();
      let dateDay = today.getDate();

      this.showGenerationDataInfoNow = false;

      if (month < 10) month = "0" + month;
      if (dateDay < 10) dateDay = "0" + dateDay;

      let randomNumber = Math.floor(Math.random() * (18 - 12 + 1)) + 12;
      let date = month + "/" + dateDay + "/" + year;

      let obj = {
        onlyPlan: "false",
        chatgptQuestion: { title: this.manuelArticle.data["requeste"] },
        dataForm: {
          publication_date: { value: date },
          publication_time: { value: randomNumber + ":00" },
          publication_datetime: { value: "" },
          publication_id: { value: "" },
          post_compte_id: { value: "" },
          isPosted: { value: 0 },
          file_ids: { value: [] },
          user: {
            value: {
              lastname: "Jauris",
              firstname: "BOT",
              user_id: "0000000000",
              group_id: this.groupInformation.id,
            },
          },
          group: {
            value: {
              id: this.groupInformation.id,
              assistant_id: this.groupInformation.assistant_id,
              album_data: this.groupInformation.album_data,
            },
          },
          thread: { value: "" },
          tags: { value: "" },
          metadata: { value: "" },
          optionalContent: { value: { content: {} } },
        },
      };
      obj["selectedTemplate"] = {};

      console.log("1", this.groupInformation.templates.content);
      console.log("2", this.manuelArticle.data.type.idx);

      obj["selectedTemplate"]["content"] = this.groupInformation.templates.content.find(
        (val) => val.idx == this.manuelArticle.data["type"].idx
      );

      console.log("content1", obj["selectedTemplate"]["content"]);
      console.log("basicData", obj["selectedTemplate"]["content"]);

      if (obj["selectedTemplate"]["content"] == undefined)
        obj["selectedTemplate"]["content"] = this.basicData.templates.content.find(
          (val) => val.idx == this.manuelArticle.data["type"].idx
        );

      console.log("content2", obj["selectedTemplate"]["content"]);

      if (
        this.groupInformation.web_site_data &&
        this.groupInformation.web_site_data[obj["selectedTemplate"]["content"].type]
      )
        obj["selectedSite"] = this.groupInformation.web_site_data[
          obj["selectedTemplate"]["content"].type
        ].find((val) => val.uuid == this.manuelArticle.data["site"]);

      if (this.manuelArticle.data.idBlog && this.manuelArticle.data.idBlog.id)
        obj.dataForm["post_compte_id"] = {
          value: { id: this.manuelArticle.data.idBlog.id },
        };

      that.manuelArticle.data.isGenerate = 1;

      that.updatePublication();

      if (that.userInformation.klaviyo && that.userInformation.klaviyo.length > 0) {
        obj["klaviyo"] = that.userInformation.klaviyo;
        engine.set_klaviyo_event(
          that.userInformation.klaviyo,
          "Génération manuelle d'un article : " + obj.chatgptQuestion.title
        );
      }

      // console.log("obj", obj);

      if (
        obj.selectedTemplate.content == undefined ||
        obj.selectedTemplate.content.type == undefined ||
        obj.selectedTemplate.content.type == "article_seo"
      ) {
        engine.creat_shopify_article_from_server(obj, function () {
          that.getSquedueldata();
        });

        setTimeout(function () {
          that.updateData();
        }, 2000);
      }
    },

    setArticleByIndex(autoPostData, isArticleSelected, slotData) {
      let index = autoPostData[slotData.site]["nbr_progra"].findIndex(
        (val) => val.uuid == slotData.uuid
      );

      autoPostData[isArticleSelected["uuid"]]["nbr_progra"][index]["requeste"] =
        isArticleSelected["data"].questionVerified;
      this.isArticleSelected = {
        //   value: false,
        //   num: 1,
      };
      this.closeModalAndSave();
    },
    // setArticleByIndex(autoPostData, isArticleSelected) {
    //   autoPostData[isArticleSelected["uuid"]]["nbr_progra"][isArticleSelected["num"] - 1][
    //     "requeste"
    //   ] = isArticleSelected["data"].questionVerified;
    //   this.isArticleSelected = {
    //     value: false,
    //     num: 1,
    //   };
    //   this.closeModalAndSave();
    // },
    setArticle(uuid, elem) {
      console.log("setArticle", uuid, elem);

      // this.isArticleSelected["value"] = true;
      this.isArticleSelected["data"] = elem;
      this.isArticleSelected["uuid"] = uuid;
    },
    closeModalAndSave() {
      let that = this;

      if (that.autoPostData)
        engine.set_auto_post_data(
          that.groupInformation.id,
          JSON.stringify(that.autoPostData),
          function () {
            if (that.updateCalendar) that.updateCalendar(that.autoPostData);
          }
        );
      this.isSavePageOpen = false;
    },
    getHeaderFromPlatform(platform) {
      let header = [];

      if (this.isBigEnougth)
        header.push({
          label: "",
          value: "nbr",
          cols: "auto",
          md: "auto",
          lg: "auto",
          xl: "auto",
        });

      header = header.concat([
        {
          label: "Jour de publication",
          value: "date",
          help: "Génération de l'article dans votre espace à J-1 avant la publication",
          cols: "12",
          md: "auto",
          lg: "auto",
          xl: "auto",
        },
        {
          label: "Article",
          value: "requeste",
          width: "40%",
          minWidth: "400px",
          help:
            "Sélectionnez un thème d'article à utiliser pour votre prochain post (si aucun thème n'est choisi, un sera sélectionné automatiquement).",
          cols: "12",
          md: "",
          lg: "",
          xl: "",
        },
      ]);

      let type = this.groupInformation.templates.content.filter(
        (val) => val.type == platform && val.show == true
      );
      // let display = this.groupInformation.templates.display.filter(
      //   (val) => val.platform == platform && val.show == true
      // );
      // let length = this.groupInformation.templates.length.filter(
      //   (val) => val.platform == platform && val.show == true
      // );

      // let BlogToPublish = [];

      // if (this.blogToPublish[this.selectedPlatformToShow]) {
      //   BlogToPublish = this.blogToPublish[this.selectedPlatformToShow];
      // }

      if (type.length > 1)
        header.push({
          label: "Type",
          value: "type",
          cols: "auto",
          md: "auto",
          lg: "auto",
          xl: "auto",
        });

      // if (display.length > 1)
      //   header.push({
      //     label: "Affichage",
      //     value: "display",
      //     cols: "auto",
      //     md: "auto",
      //     lg: "auto",
      //     xl: "auto",
      //   });

      // if (this.redacteurListe.length > 1)
      //   header.push({
      //     label: "Rédacteur",
      //     value: "redacteur",
      //     cols: "auto",
      //     md: "auto",
      //     lg: "auto",
      //     xl: "auto",
      //   });

      // if (this.groupInformation.web_site_data[this.selectedPlatformToShow].length > 1)
      //   header.push({
      //     label: "Site de publication",
      //     value: "site",
      //     cols: "auto",
      //     md: "auto",
      //     lg: "auto",
      //     xl: "auto",
      //   });

      // if (BlogToPublish.length > 1)
      //   header.push({
      //     label: "Blog de publication",
      //     value: "idBlog",
      //     cols: "auto",
      //     md: "auto",
      //     lg: "auto",
      //     xl: "auto",
      //   });

      // if (length.length > 1)
      //   header.push({
      //     label: "Longueur",
      //     value: "length",
      //     cols: "12",
      //     md: "auto",
      //     lg: "auto",
      //     xl: "auto",
      //   });

      header.push({
        label: "Générer maintenant",
        value: "generatetNow",
        width: "10%",
        minWidth: "220px",
        cols: "auto",
        md: "auto",
        lg: "auto",
        xl: "auto",
      });

      header.push({
        label: "Activer",
        help: "Activer la génération automatique",
        value: "isActived",
        // width: "200px",
        minWidth: "100px",
        cols: "auto",
        md: "auto",
        lg: "auto",
        xl: "auto",
      });

      return header;
    },
    addGeneration(platform, id, key, site) {
      if (this.programationData[id] == undefined) this.programationData[id] = {};
      if (this.programationData[id][key] == undefined)
        this.programationData[id][key] = [];

      let type = this.groupInformation.templates.content.filter(
        (val) => val.type == platform && val.show == true
      );

      if (type.length == 0) type = this.basicData.templates.content;

      // let display = this.groupInformation.templates.display.filter(
      //   (val) => val.platform == platform && val.show == true
      // );
      // let length = this.groupInformation.templates.length.filter(
      //   (val) => val.platform == platform && val.show == true
      // );
      // let  redacteur = this.redacteurListe.find((val) => val.default_selected == true).map((val2) => ({idx:val2.idx}));
      let idBlog = undefined;

      if (site.publication_platform_data && site.publication_platform_data.length > 0) {
        let publication_platform_data = JSON.parse(site.publication_platform_data);
        idBlog = publication_platform_data[0];
      }

      let item = {
        date: 1,
        // redacteur,
        type: type[0].idx,
        // display: display[0],
        // length: length[0],
        site: site.uuid,
        idBlog,
        requeste: "",
        isGenerate: 0,
        isActived: 1,
        uuid: uuidv4(),
      };

      if (this.autoPostData[id] == undefined) this.autoPostData[id] = {};
      if (this.autoPostData[id][key] == undefined) this.autoPostData[id][key] = [];

      this.autoPostData[id][key].push(item);
    },
    removeGeneration(id, key) {
      // if (this.programationData[id] == undefined)
      //     this.programationData[id] = {}
      // if (this.programationData[id][key] == undefined)
      //     this.programationData[id][key] = []
      this.autoPostData[id][key].splice(-1);
    },
  },
  mounted() {
    // this.getBlogs();
    this.initPostData();

    this.selectedSiteToShow = this.groupInformation.web_site_data[
      this.selectedPlatformToShow
    ][0];
    this.setManualInfo();
  },
};
</script>

<style>
.text-center .v-list-item-title {
  text-align: center;
  width: 100%;
}
.no-dropdown-icon .v-field__append-inner {
  display: none;
}
</style>
